import { render, staticRenderFns } from "./workHistory.vue?vue&type=template&id=2589dc18&scoped=true&"
import script from "./workHistory.vue?vue&type=script&lang=js&"
export * from "./workHistory.vue?vue&type=script&lang=js&"
import style0 from "./workHistory.vue?vue&type=style&index=0&id=2589dc18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589dc18",
  null
  
)

export default component.exports